import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container-row align-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataItem.serialNo)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          id: _ctx.id,
          class: "grid-id-link flex-container-row gap5 align-center",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClick(_ctx.dataItem.serialNo)), ["prevent"]))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.dataItem.serialNo), 1)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.dataItem.docCount > 0)
        ? (_openBlock(), _createBlock(_component_my_icon, {
            key: 0,
            icon: "pdf",
            size: 16,
            color: "red",
            title: `${_ctx.dataItem.docCount} ${_ctx.localize('documents')}`
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.dataItem.adminOnly)
        ? (_openBlock(), _createBlock(_component_my_icon, {
            key: 1,
            icon: "lock",
            size: 16,
            color: "red",
            title: _ctx.localize('onlyVisibleForAdmins')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}